export { PartnershipTile, type PartnershipTileProps } from './PartnershipTile';
